var map = {
	"./left/amethyst-coral.png": "a4d1",
	"./left/basic.png": "1b28",
	"./left/clouds.png": "b907",
	"./left/concrete.png": "b10d",
	"./left/emerald.png": "4a12",
	"./left/midnight-blue.png": "c2da",
	"./left/orange.png": "ebed",
	"./left/pomegranate.png": "3e9e",
	"./left/pumpkin.png": "ab32",
	"./left/turquoise.png": "4fd8",
	"./right/amethyst-coral.png": "aa58",
	"./right/basic.png": "914c",
	"./right/clouds.png": "3ccf",
	"./right/concrete.png": "021a",
	"./right/emerald.png": "1e39",
	"./right/midnight-blue.png": "c850",
	"./right/orange.png": "18c5",
	"./right/pomegranate.png": "4c27",
	"./right/pumpkin.png": "9745",
	"./right/turquoise.png": "8bf5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a564";